var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isMaterial
    ? _c(
        "div",
        { staticClass: "ah-card-header" },
        [
          _c("img", {
            staticClass: "ah-card-header-image",
            attrs: { src: _vm.image.src + "?width=256", alt: _vm.heading }
          }),
          _vm._v(" "),
          _c("species-icons", { attrs: { species: _vm.species } })
        ],
        1
      )
    : _c("div", { staticClass: "ah-card-header" }, [
        _c(
          "a",
          { attrs: { href: _vm.links[0].href } },
          [
            _c("img", {
              staticClass: "ah-card-header-image",
              attrs: { src: _vm.image.src + "?width=256", alt: _vm.heading }
            }),
            _vm._v(" "),
            _c("species-icons", { attrs: { species: _vm.species } })
          ],
          1
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }